// extracted by mini-css-extract-plugin
export default {"DecimalContainer":"_DecimalContainer--BvSe0","DecimalTitle":"_DecimalTitle--dn3qG","Select":"_Select--w3H73","InfoIcon":"_InfoIcon--CIo1J"};